import { Controller } from "@hotwired/stimulus"

// 数字のみの入力を許可するコントローラー
// ハイフンやその他の文字を自動的に削除します
export default class extends Controller {
  connect() {
    // 初期値もクリーンアップ（既存データにハイフンが含まれている場合）
    if (this.element.value !== undefined) {
      this.element.value = this.sanitize(this.element.value)
    }
  }

  input(event) {
    const input = event.target
    const cursorPosition = input.selectionStart
    const originalValue = input.value
    const sanitizedValue = this.sanitize(originalValue)

    // 値が変更された場合のみ更新
    if (originalValue !== sanitizedValue) {
      input.value = sanitizedValue

      // カーソル位置を調整（削除された文字の数だけ戻す）
      const removedChars = originalValue.length - sanitizedValue.length
      const newPosition = Math.max(0, cursorPosition - removedChars)
      input.setSelectionRange(newPosition, newPosition)
    }
  }

  sanitize(value) {
    // 数字以外の文字をすべて削除
    return value.replace(/[^0-9]/g, '')
  }
}
